var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojioneV1FlagForGhana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.375H24V14.625H0V9.375Z",
    fill: "#F9CB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.75H3.75C1.26488 3.75 0 5.59688 0 7.875V9.375H24V7.875C24 5.59688 22.7351 3.75 20.25 3.75Z",
    fill: "#EC1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.125C0 18.4031 1.26488 20.25 3.75 20.25H20.25C22.7351 20.25 24 18.4031 24 16.125V14.625H0V16.125Z",
    fill: "#137A08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.917 9.68437L12.6471 11.1637L14.2802 11.403L13.0993 12.555L13.3783 14.1799L11.917 13.4122L10.456 14.1799L10.735 12.555L9.55371 11.403L11.1872 11.1637L11.917 9.68437Z",
    fill: "#25333A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneV1FlagForGhana);
export default __webpack_public_path__ + "static/media/emojione-v1_flag-for-ghana.b4b136b6ad3e03db358548036917baee.svg";
export { ForwardRef as ReactComponent };